import { UsuarioComisionFreelanceHistoricoService } from './../../_services/usuario-comision-freelance-historico.service';
import { BusquedaFiltros } from './../../_models/busqueda-filtros';
import { UsuarioComisionFreelanceService } from './../../_services/usuario-comision-freelance.service';
import { AutenticacionService } from "./../../_services/autenticacion.service";
import { NavService } from "./../../_services/_nav.service";
import { Funcionalidad } from "./../../_models/funcionalidad";
import { UsuarioComisionFreelance } from "./../../_models/usuario-comision-freelance";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Table } from "primeng/table";
import { Router } from "@angular/router";
import { UsuarioComisionFreelanceHistorico } from './../../_models/usuario-comision-freelance-historico';

@Component({
  selector: "app-comision-freelance-listado",
  templateUrl: "./comision-freelance-listado.component.html",
  styleUrls: ["./comision-freelance-listado.component.css"],
})
export class ComisionFreelanceListadoComponent implements OnInit {
  formulario: FormGroup;
  carComisionFreelance = true;
  usuariosComisionesFreelance: UsuarioComisionFreelance[] = [];
  usuariosComisionesFreelanceHistoricos: UsuarioComisionFreelanceHistorico[] = [];
  columnas: any[];
  colHistoricos: any[];
  busqueda: string;
  @ViewChild("dt", { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();
  pagina: string;
  regPorPagina = 10;
  numRegistros: number;
  submitted = false;
  mosModalHistorico = false;
  carInformacionHistorico = true;

  constructor(
    private navServicio: NavService,
    private autServicio: AutenticacionService,
    private router: Router,
    private fb: FormBuilder,
    private usuariosComisionesFreelanceService: UsuarioComisionFreelanceService,
    private usuariosComisionesFreelanceHistoricosService: UsuarioComisionFreelanceHistoricoService
  ) { }

  ngOnInit() {
    const mn = this.autServicio.obtenerFuncionalidades().find((x) => x.ruta === "apl/comision-freelance");
    if (mn) {
      this.menu = mn;
    }
    this.setearColumnas();
    this.cargarFormulario();
  }

  setearColumnas() {

    this.columnas = [
      {
        field: 'identificacion',
        header: this.navServicio.buscarMensaje('USUARIOCOMISIONFREELANCE.LBL_IDENTIFICACION'),
        sort: false,
      },
      {
        field: 'freelance',
        header: this.navServicio.buscarMensaje('USUARIOCOMISIONFREELANCE.LBL_FREELANCE'),
        sort: false,
      },
      {
        field: 'usuario',
        header: this.navServicio.buscarMensaje('USUARIOCOMISIONFREELANCE.LBL_USUARIO'),
        sort: false,
      },
      {
        field: 'comision',
        header: this.navServicio.buscarMensaje('USUARIOCOMISIONFREELANCE.LBL_COMISION'),
        sort: false,
      },
      {
        field: 'base',
        header: this.navServicio.buscarMensaje('USUARIOCOMISIONFREELANCE.LBL_BASE'),
        sort: false,
      },
      {
        field: 'indicadorHabilitado',
        header: this.navServicio.buscarMensaje('USUARIOCOMISIONFREELANCE.LBL_HABILITADO'),
        sort: false,
      },
      {
        field: 'det',
        header: this.navServicio.buscarMensaje('LBL_ACCIONES'),
        sort: false,
      },
    ];

    this.colHistoricos = [
      {
        field: 'fechaHora',
        header: this.navServicio.buscarMensaje('USUARIOCOMISIONFREELANCEHISTORICO.LBL_FECHAHORA'),
        sort: false,
      },
      {
        field: 'usuarioModifica',
        header: this.navServicio.buscarMensaje('USUARIOCOMISIONFREELANCEHISTORICO.LBL_USUARIOMODIFICA'),
        sort: false,
      },
      {
        field: 'ipPublica',
        header: this.navServicio.buscarMensaje('USUARIOCOMISIONFREELANCEHISTORICO.LBL_IPPUBLICA'),
        sort: false,
      },
      {
        field: 'ipLocal',
        header: this.navServicio.buscarMensaje('USUARIOCOMISIONFREELANCEHISTORICO.LBL_IPLOCAL'),
        sort: false,
      },
      {
        field: 'datoAnterior',
        header: this.navServicio.buscarMensaje('USUARIOCOMISIONFREELANCEHISTORICO.LBL_DATOANTERIOR'),
        sort: false,
      },
      {
        field: 'datoNuevo',
        header: this.navServicio.buscarMensaje('USUARIOCOMISIONFREELANCEHISTORICO.LBL_DATONUEVO'),
        sort: false,
      },
    ];


    this.carComisionFreelance = false;
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      filtro: [null]
    })
  }

  get f() {
    return this.formulario.value;
  }

  buscar(event?: any) {
    this.buscarPorFiltros(event);
  }

  buscarPorFiltros(event?: any) {
    const formulario = this.formulario.getRawValue();
    this.submitted = true;
    if (this.formulario.valid) {
      this.carComisionFreelance = true;
      if (event) {
        this.pagina = String(event.first / this.regPorPagina);
      } else {
        this.pagina = '0';
        this.tabla.first = 0;
      }
      const a = new BusquedaFiltros();
      a.pagina = Number(this.pagina);
      a.cantidad = this.regPorPagina;
      a.search = this.f.filtro ? this.f.filtro : null;

      this.navServicio.setFilters('comision-freelance', 'filtro', formulario.filtro);

      this.usuariosComisionesFreelanceService.buscadorRegistrosUsuariosComisionesFreelance(a).subscribe(rta => {
        this.numRegistros = Number(rta.total);
        this.usuariosComisionesFreelance = rta.data;
        this.carComisionFreelance = false;
        this.submitted = false;
      }, e => {
        this.carComisionFreelance = false;
        this.submitted = false;
        this.navServicio.setMesage(0,
          {
            severity: 'error',
            summary: this.navServicio.buscarMensaje('LBL_ERROR'),
            detail: this.navServicio.buscarMensaje('MSG_ERRORCARGAR')
          });
      });
    }
  }

  crearComisionFreelance() {
    this.router.navigate(['apl/comision-freelance/agregar']);
  }

  verComisionFreelance(comisionFreelance: UsuarioComisionFreelance) {
    this.router.navigate(['apl/comision-freelance/detalle/' + comisionFreelance.idUsuarioComisionFreelance]);
  }

  editarComisionFreelance(comisionFreelance: UsuarioComisionFreelance) {
    this.router.navigate(['apl/comision-freelance/actualizar/' + comisionFreelance.idUsuarioComisionFreelance]);
  }

  historialComisionFreelance(comisionFreelance: UsuarioComisionFreelance) {
    this.mosModalHistorico = true;
    this.usuariosComisionesFreelanceHistoricosService.listadoPorUsuarioFreelance(comisionFreelance.idUsuarioComisionFreelance).subscribe((res)=>{
      this.usuariosComisionesFreelanceHistoricos = res;
      this.carInformacionHistorico = false;
    })


  }

  cerrarModalHistorico () {
    this.mosModalHistorico = false;
  }
}
